// Per-type presentation + click behavior for in-app notifications.
//
// Each notification carries a `type` and a `data` payload. The bell renders the
// matched entry's icon/color and runs its `action` on click. Add new event
// types here (a redirect, a different download, etc.) without touching the bell.
//
// action.kind: 'download-combined' | 'navigate' | 'none'
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined'
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined'
import BellOutlined from '@ant-design/icons/BellOutlined'

const REGISTRY = {
  // Combined invoice/statement export finished (or failed).
  invoiceBatchExport: (item) => {
    const failed = item.data?.status === 'failed'
    return {
      Icon: failed ? CloseCircleOutlined : FilePdfOutlined,
      color: failed ? 'error' : 'success',
      action: failed
        ? { kind: 'navigate', to: item.link || '/billing/invoices' }
        : { kind: 'download-combined', id: item.data?.batchExportId }
    }
  }
}

const fallback = (item) => ({
  Icon: BellOutlined,
  color: 'primary',
  action: item.link ? { kind: 'navigate', to: item.link } : { kind: 'none' }
})

export const notificationView = (item) => (REGISTRY[item.type] || fallback)(item)
